import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({

  coursesSearchPlaceholder: {
    id: 'course-authoring.studio-home.courses.search-placeholder',
    defaultMessage: 'Search',
  },
});

export default messages;
